import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import PageTransition from './PageTransition';
import CustomCursor from './CustomCursor';

const MerchPage = () => {
  const navigate = useNavigate();
  
  return (
    <PageTransition>
      <CustomCursor />
      <div className="album-page">
        <button 
          className="album-close-button"
          onClick={() => navigate('/')}
          aria-label="Close"
        >
          <X size={24} />
        </button>
        
        <div className="album-content">
          <h1 className="album-title glitch-title" data-text="merch">merch</h1>
          
          <div className="coming-soon">
            <p>Coming Soon</p>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};

export default MerchPage;
